import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { recalculateLayout, redo, switchBreakpoint, undo, updateToolsSettings } from 'actions/editor';

import _ from 'lodash';
import cx from 'classnames';

import { DesktopButton, GridlinesButton, HeaderContext, LayersButton, MobileButton, OptimizeLayoutButton, PageAction, PaletteButton, RedoButton, RulerButton, ToolsButton, UndoButton } from 'pages/pages/components/header';

import styles from './liveElement.module.scss';
import { MIXPANEL_PAGE_VIEWED, MIXPANEL_PAGE_VIEWED_EDITOR } from 'constants/mixpanelEvents';
import { createMixpanelEvent } from 'actions/mixpanel';
import { getPageViewedEventPayload } from 'services/mixpanelUtil';

export const LiveElementHeader = ({ editorSession, target }) => {
  const dispatch = useDispatch();

  const [state, setState] = useState({
    selected: null,
  });

  const breakpoint = useSelector((state) => _.get(state, `${editorSession}.present.breakpoint`));
  const canUndo = useSelector((state) => _.size(_.get(state, `${editorSession}.past`)) > 0);
  const canRedo = useSelector((state) => _.size(_.get(state, `${editorSession}.future`)) > 0);
  const tools = useSelector((state) => _.get(state, `${editorSession}.present.tools`));
  const activePage = useSelector((state) => _.get(state, `${editorSession}.present.interactive.active`));
  const layoutChangeIndicator = useSelector(state => _.get(state, `${editorSession}.present.layoutIndicator`));

  const handleUndo = () => {
    dispatch(undo(editorSession));
  };

  const handleRedo = () => {
    dispatch(redo(editorSession));
  };

  const handleSwitchBreakpoint = (breakpoint) => {
    dispatch(switchBreakpoint(editorSession, breakpoint));

    var mixPanelPayload = getPageViewedEventPayload(MIXPANEL_PAGE_VIEWED_EDITOR)
    mixPanelPayload = {
      ...mixPanelPayload,
      editor_type: 'Live Element',
      device_type: capitalizeFirstLetter(breakpoint)
    }
    dispatch(createMixpanelEvent(MIXPANEL_PAGE_VIEWED, mixPanelPayload))
};

const capitalizeFirstLetter = (value) => {
  if (value) {
    value = value.charAt(0).toUpperCase() + value.slice(1);
  }
  return value;
}

  const handleButtonSelection = (active) => {
    setState((state) => {
      return {
        ...state,
        selected: active
      };
    });
  };

  const handleCloseSlider = () => {
    setState((state) => {
      return {
        ...state,
        selected: null,
      };
    });
  };

  const toggleOption = (option) => {
    const value = _.get(tools, option, false);

    var request = {
      [option]: !value
    };

    dispatch(updateToolsSettings(editorSession, request));
  }

  const handleOptimizeLayout = () => {
    dispatch(recalculateLayout(editorSession, activePage));
  }

  return (
    <>
      <div className={cx(styles.menu, styles.secondary)}>
        <div className={cx(styles.actions, styles.paletteActions)}>
          <PaletteButton onButtonSelection={handleButtonSelection} selected={state.selected} />
        </div>
        <div className={styles.actions}>
          <ToolsButton tools={tools} onToggle={toggleOption} />
          <LayersButton tools={tools} onToggle={toggleOption} />
        </div>
        <div className={styles.actions}>
          <UndoButton canUndo={canUndo} onUndo={handleUndo} />
          <RedoButton canRedo={canRedo} onRedo={handleRedo} />
        </div>
        <div className={cx(styles.actions, styles.right, styles.breakpoint)}>
          {breakpoint === "mobile" &&
            <OptimizeLayoutButton onOptimizeLayout={handleOptimizeLayout} />
          }
          <div className={styles.group}>
            <DesktopButton breakpoint={breakpoint} onSwitchBreakpoint={handleSwitchBreakpoint} />
            <MobileButton breakpoint={breakpoint} layoutChangeIndicator={layoutChangeIndicator} onSwitchBreakpoint={handleSwitchBreakpoint} />
          </div>
        </div>
        <div className={cx(cx(styles.actions, styles.tools))}>
          <RulerButton tools={tools} onToggle={toggleOption} />
          <GridlinesButton tools={tools} onToggle={toggleOption} />
        </div>
      </div>
      <PageAction
        editorSession={editorSession}
        selected={state.selected}
        onClose={handleCloseSlider}
        storyboard={null}
        target={target}
      />
    </>
  );
};
